var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"white",attrs:{"src":_vm.url,"lazy-src":require("../../assets/img/user.png"),"contain":""},on:{"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }